import axios from "axios";
import { toast } from "react-toastify";

//////////////////////
const API_BASE_URL = process.env.backendUrl || "https://api.adhyayi.com/api/";
// const API_BASE_URL = process.env.backendUrl || "https://learn2earn-backend-staging.onrender.com/api/";
// 
// const API_BASE_URL = process.env.backendUrl || "https://api.learn2earn24x7.com/api/";
//////////////////////
// const API_BASE_URL = "https://learn2earn-backend.vercel.app/api/";
// const API_BASE_URL = "https://ad-04b9baf20406429ca19a28b8a9fe4da6.ecs.ap-south-1.on.aws/api/";
// const API_BASE_URL = "http://localhost:8001/api/";


// ADD THIS FUNCTION HERE 👇
function getDeviceInfo() {
  return navigator.userAgent + "-" + navigator.platform;
}

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  // withCredentials:true,
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Add device ID always
    config.headers["X-Device-Id"] = getDeviceInfo();
    return config;
  },
  (err) => {
    Promise.reject(err);
  }
);

// Response interceptor to auto-logout on 401
instance.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      const reason = err?.response?.data?.message;
      // clear stored token and redirect to login
      localStorage.removeItem("token");
      const bc = new BroadcastChannel("auth");
      bc.postMessage("logout");

      if (reason === "another_device_login") {
        toast.error(
          "Your account has been logged in from another device. Please log in again."
        );
        window.location.href = "/login?reason=other_device";
      } else {
        toast.error("Session expired, please log in again.");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
export default instance;